module.exports = __webpack_public_path__ + "media/logos/logo_foot-3df2d804.png";